import type { ActivePreorderCampaign } from '../../../hooks/queries/usePreorders';

export interface PreorderCampaignSelectProps {
  campaigns: ActivePreorderCampaign[];
  onSelect: (campaign: ActivePreorderCampaign) => void;
  normalizeImageUrl: (url: string | null | undefined) => string | null;
}

/**
 * 多檔期時的活動列表（選擇預購活動）
 */
export function PreorderCampaignSelect({
  campaigns,
  onSelect,
  normalizeImageUrl,
}: PreorderCampaignSelectProps) {
  return (
    <div className="min-h-screen bg-slate-50 px-4 py-6 pb-20">
      <h1 className="text-xl font-bold text-gray-900 mb-2">選擇預購活動</h1>
      <p className="text-sm text-gray-600 mb-4">
        目前有多個預購活動進行中，請選擇要參與的活動
      </p>
      <div className="space-y-3">
        {campaigns.map(c => {
          const bannerUrl = (c as { bannerImageUrl?: string | null })
            .bannerImageUrl;
          const hasBanner = Boolean(bannerUrl);
          return (
            <button
              key={c.id}
              type="button"
              onClick={() => onSelect(c)}
              className="w-full text-left rounded-xl shadow-md p-4 border border-gray-200 hover:border-blue-400 hover:shadow-lg transition-all active:scale-[0.99] overflow-hidden relative min-h-[100px]"
              style={
                hasBanner
                  ? {
                      backgroundImage: `url(${normalizeImageUrl(bannerUrl!)})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                    }
                  : { backgroundColor: 'white' }
              }
            >
              {hasBanner ? (
                <span className="absolute inset-0 bg-black/40" aria-hidden />
              ) : null}
              <span className="relative z-10 block">
                <h2
                  className={
                    hasBanner
                      ? 'font-semibold text-white drop-shadow-md'
                      : 'font-semibold text-gray-900'
                  }
                >
                  {c.campaignName}
                </h2>
                <p
                  className={
                    hasBanner
                      ? 'text-xs text-white/90 mt-1 drop-shadow'
                      : 'text-xs text-gray-500 mt-1'
                  }
                >
                  {c.startsAtTaipei.split(' ')[0]} 至{' '}
                  {c.endsAtTaipei.split(' ')[0]}
                </p>
                {c.campaignCopy ? (
                  <p
                    className={
                      hasBanner
                        ? 'text-sm text-white/90 mt-2 line-clamp-2 drop-shadow'
                        : 'text-sm text-gray-600 mt-2 line-clamp-2'
                    }
                  >
                    {c.campaignCopy}
                  </p>
                ) : null}
                <p
                  className={
                    hasBanner
                      ? 'text-xs text-blue-200 mt-2'
                      : 'text-xs text-blue-600 mt-2'
                  }
                >
                  點擊進入 →
                </p>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
